"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[12786,7639,93996,64626,94562],{

/***/ 28635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ TrendingTimeFrame; }
/* harmony export */ });
var TrendingTimeFrame;
(function(TrendingTimeFrame) {
    TrendingTimeFrame["ALL"] = "TIME_FRAME_ALL";
    TrendingTimeFrame["ONE_WEEK"] = "TIME_FRAME_1W";
    TrendingTimeFrame["ONE_MONTH"] = "TIME_FRAME_1M";
})(TrendingTimeFrame || (TrendingTimeFrame = {}));


/***/ }),

/***/ 40927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(36305);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(61876);
/* harmony import */ var constants_successMessage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41208);
/* harmony import */ var global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25516);
/* harmony import */ var lib_api_setting__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45621);
/* harmony import */ var lib_api_friends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63699);
/* harmony import */ var lib_api_user__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1955);
/* harmony import */ var lib_api_trade__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65141);
/* harmony import */ var utils_uploadFile__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78603);








// APIs




// Utils

// Initial state
var initialState = {
    getChangePasswordToken: {
        data: {
            change_token: ""
        },
        isLoading: false,
        message: "",
        error: null
    },
    updatePassword: {
        data: {},
        isLoading: false,
        message: "",
        error: null
    },
    blockedUsers: {
        data: [],
        isLoading: false,
        message: "",
        error: null,
        isLastPage: true
    },
    notifications: {
        data: [],
        isLoading: false,
        message: "",
        error: null
    },
    changePhone: {
        phone: "",
        successVerify: false,
        isLoading: false,
        error: null
    },
    changeAvatar: {
        avatar: "",
        message: "",
        error: null,
        isLoading: false
    },
    tradingAccounts: {
        data: {},
        message: "",
        error: null,
        isLoading: false
    },
    avatar3DList: {
        data: [],
        message: "",
        error: null,
        isLoading: false
    },
    invitationSetting: {
        data: {
            group_setting: ""
        },
        message: "",
        error: null,
        isLoading: false
    },
    blacklistStatus: {
        status: false,
        message: "",
        error: null,
        isLoading: false
    }
};
// Reducers
var reducers = {
    changePhoneNumber: function(state, action) {
        state.changePhone.phone = action.payload;
    }
};
// Selectors
var editProfile = function(state) {
    return state.editProfile;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(editProfile, function(profile) {
    return {
        getChangePasswordToken: profile.getChangePasswordToken,
        updatePassword: profile.updatePassword,
        blockedUsers: profile.blockedUsers,
        notifications: profile.notifications,
        changePhone: profile.changePhone,
        avatar3DList: profile.avatar3DList,
        changeAvatar: profile.changeAvatar,
        tradingAccounts: profile.tradingAccounts,
        invitationSetting: profile.invitationSetting,
        blacklistStatus: profile.blacklistStatus
    };
});
// Action types
var CONTEXT = "@feature/edit-profile";
var actionType = {
    GET_CHANGE_PASSWORD_TOKEN: "".concat(CONTEXT, "/GET_CHANGE_PASSWORD_TOKEN"),
    UPDATE_PASSWORD: "".concat(CONTEXT, "/UPDATE_PASSWORD"),
    UPDATE_DISCOVERABLE_PRIVACY: "".concat(CONTEXT, "/UPDATE_DISCOVERABLE_PRIVACY"),
    GET_BLOCKED_USER: "".concat(CONTEXT, "/GET_BLOCKED_USER"),
    UNBLOCK_USER: "".concat(CONTEXT, "/UNBLOCK_USER"),
    DISCONNECT_SOCIAL_MEDIA: "".concat(CONTEXT, "/DISCONNECT_SOCIAL_MEDIA"),
    GET_NOTIFICATIONS: "".concat(CONTEXT, "/GET_NOTIFICATIONS"),
    UPDATE_NOTIFICATION: "".concat(CONTEXT, "/UPDATE_NOTIFICATION"),
    CHANGE_PHONE_NUMBER: "".concat(CONTEXT, "/CHANGE_PHONE_NUMBER"),
    VERIFY_PHONE_NUMBER: "".concat(CONTEXT, "/VERIFY_PHONE_NUMBER"),
    GET_AVATAR3D_LIST: "".concat(CONTEXT, "/GET_AVATAR3D_LIST"),
    CHANGE_AVATAR: "".concat(CONTEXT, "/CHANGE_AVATAR"),
    GET_TRADING_ACCOUNTS: "".concat(CONTEXT, "/GET_TRADING_ACCOUNTS"),
    UNLINK_TRADING_ACCOUNT: "".concat(CONTEXT, "/UNLINK_TRADING_ACCOUNT"),
    GET_INVITATION_SETTING: "".concat(CONTEXT, "/GET_INVITATION_SETTING"),
    UPDATE_INVITATION_SETTING: "".concat(CONTEXT, "/UPDATE_INVITATION_SETTING"),
    GET_BLOCKLIST_STATUS: "".concat(CONTEXT, "/GET_BLOCKLIST_STATUS"),
    UPDATE_BLOCKLIST_STATUS: "".concat(CONTEXT, "/UPDATE_BLOCKLIST_STATUS")
};
// Helper
var handleUploadAvatar = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(file) {
        var avatarUrl, upload, uploadedUrl;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    avatarUrl = "";
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return (0,utils_uploadFile__WEBPACK_IMPORTED_MODULE_7__/* .uploadFiles */ .IL)([
                        file
                    ], "avatar");
                case 4:
                    upload = _ctx.sent;
                    if (!upload.error) {
                        _ctx.next = 7;
                        break;
                    }
                    throw new Error(upload);
                case 7:
                    uploadedUrl = upload.map(function(res) {
                        return res.data.url;
                    });
                    avatarUrl = uploadedUrl.join();
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](1);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 14:
                    return _ctx.abrupt("return", {
                        data: avatarUrl
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                11
            ]
        ]);
    }));
    return function handleUploadAvatar(file) {
        return _ref.apply(this, arguments);
    };
}();
var effects = {
    getChangePasswordToken: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)(actionType.GET_CHANGE_PASSWORD_TOKEN, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(password) {
            var requestTokenData, response, _data, _$error, data, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        requestTokenData = {
                            password: password,
                            req_type: "CHANGE_TOKEN_REQ_TYPE_EDIT",
                            type: "CHANGE_TOKEN_TYPE_PASSWORD"
                        };
                        _ctx.next = 4;
                        return lib_api_setting__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getChangePasswordToken */ .ZP.getChangePasswordToken(requestTokenData);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to update password failed");
                    case 7:
                        _data = response.data, _$error = _data.error, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }));
        return function(password) {
            return _ref.apply(this, arguments);
        };
    }()),
    updatePassword: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)(actionType.UPDATE_PASSWORD, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(passwordData) {
            var response, _data, _$error, data, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_setting__WEBPACK_IMPORTED_MODULE_3__/* ["default"].updatePassword */ .ZP.updatePassword(passwordData);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to update password failed");
                    case 6:
                        _data = response.data, _$error = _data.error, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(constants_successMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"].PASSWORD_CHANGED */ .Z.PASSWORD_CHANGED, constants_successMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ALERT_GREEN */ .Z.ALERT_GREEN);
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }));
        return function(passwordData) {
            return _ref.apply(this, arguments);
        };
    }()),
    updatePrivacy: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)(actionType.UPDATE_DISCOVERABLE_PRIVACY, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, _data, _$error, data, message;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_friends__WEBPACK_IMPORTED_MODULE_4__/* ["default"].updateBlacklistStatus */ .Z.updateBlacklistStatus();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to update discoverable privacy failed");
                case 6:
                    _data = response.data, _$error = _data.error, data = _data.data, message = _data.message;
                    if (!_$error) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        error: _$error,
                        message: message
                    });
                case 9:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }))),
    getBlockedUsers: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)(actionType.GET_BLOCKED_USER, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(page) {
            var response, _data, _$error, message, data, sanitizedData;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_user__WEBPACK_IMPORTED_MODULE_5__/* ["default"].getBlockedUser */ .Z.getBlockedUser(page);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to get blocked user failed");
                    case 6:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        sanitizedData = data.blocked_list;
                        return _ctx.abrupt("return", {
                            data: sanitizedData,
                            message: message,
                            more: data.more
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }));
        return function(page) {
            return _ref.apply(this, arguments);
        };
    }()),
    unblockUser: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)(actionType.UNBLOCK_USER, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(userid) {
            var response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_user__WEBPACK_IMPORTED_MODULE_5__/* ["default"].unblockUser */ .Z.unblockUser(userid);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to unblock user failed");
                    case 6:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(message, constants_successMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ALERT_GREEN */ .Z.ALERT_GREEN);
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            userid: userid
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }));
        return function(userid) {
            return _ref.apply(this, arguments);
        };
    }()),
    disconnectSocialMedia: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)(actionType.DISCONNECT_SOCIAL_MEDIA, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var socialMedia, password, requestBody, response, _data, _$error, data, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        socialMedia = param.socialMedia, password = param.password;
                        _ctx.prev = 1;
                        requestBody = {
                            password: password
                        };
                        _ctx.next = 5;
                        return lib_api_user__WEBPACK_IMPORTED_MODULE_5__/* ["default"].disconnectSocialMedia */ .Z.disconnectSocialMedia(socialMedia, requestBody);
                    case 5:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error("Attempt to disconnect social media failed");
                    case 8:
                        _data = response.data, _$error = _data.error, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 11;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 11:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    14
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getNotifications: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)(actionType.GET_NOTIFICATIONS, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, _data, _$error, data, message;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_setting__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getNotificationSettings */ .ZP.getNotificationSettings();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get user notifications failed");
                case 6:
                    _data = response.data, _$error = _data.error, data = _data.data, message = _data.message;
                    if (!_$error) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        error: _$error,
                        message: message
                    });
                case 9:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }))),
    updateNotification: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)(actionType.UPDATE_NOTIFICATION, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(requestBody, param) {
            var getState, response, _data, data, _$error, message, ref, _editProfile, _notifications, notifData, dataUpdated;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        getState = param.getState;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_setting__WEBPACK_IMPORTED_MODULE_3__/* ["default"].updateNotificationSetting */ .ZP.updateNotificationSetting(requestBody);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to update notification setting failed");
                    case 7:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        ref = getState(), _editProfile = ref.editProfile, _notifications = _editProfile.notifications, notifData = _notifications.data;
                        dataUpdated = notifData.map(function(notifList) {
                            var currentData = notifList.notifications;
                            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, notifList), {
                                notifications: currentData.map(function(currNotifData) {
                                    if (currNotifData.type === data.type) {
                                        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, data);
                                    }
                                    return currNotifData;
                                })
                            });
                        });
                        if (!_$error) {
                            _ctx.next = 12;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 12:
                        return _ctx.abrupt("return", {
                            message: message,
                            dataUpdated: dataUpdated
                        });
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    15
                ]
            ]);
        }));
        return function(requestBody, _) {
            return _ref.apply(this, arguments);
        };
    }()),
    // @ts-ignore
    getAvatar3DList: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)(actionType.GET_AVATAR3D_LIST, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, _data, _$error, data, message;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_user__WEBPACK_IMPORTED_MODULE_5__/* ["default"].getAvatar3DList */ .Z.getAvatar3DList();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get avatar 3D list failed");
                case 6:
                    _data = response.data, _$error = _data.error, data = _data.data, message = _data.message;
                    if (!_$error) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        error: _$error,
                        message: message
                    });
                case 9:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }))),
    changeAvatar: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)(actionType.CHANGE_AVATAR, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(file) {
            var dataUpload, _$error, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return handleUploadAvatar(file);
                    case 3:
                        dataUpload = _ctx.sent;
                        _$error = dataUpload.error, data = dataUpload.data;
                        if (!_$error) {
                            _ctx.next = 7;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error
                        });
                    case 7:
                        return _ctx.abrupt("return", {
                            data: data
                        });
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        }));
        return function(file) {
            return _ref.apply(this, arguments);
        };
    }()),
    getTradingAccounts: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)(actionType.GET_TRADING_ACCOUNTS, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, _data, _$error, data, message;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_trade__WEBPACK_IMPORTED_MODULE_6__/* ["default"].getTradingConfig */ .Z.getTradingConfig();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get trading config failed");
                case 6:
                    _data = response.data, _$error = _data.error, data = _data.data, message = _data.message;
                    if (!_$error) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        error: _$error,
                        message: message
                    });
                case 9:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }))),
    unlinkTradingAccount: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)(actionType.UNLINK_TRADING_ACCOUNT, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(brokerKey) {
            var response, _data, _$error, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_trade__WEBPACK_IMPORTED_MODULE_6__/* ["default"].unlinkTradingAccount */ .Z.unlinkTradingAccount(brokerKey);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to unlink trading account failed");
                    case 6:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            brokerKey: brokerKey
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(brokerKey) {
            return _ref.apply(this, arguments);
        };
    }()),
    getInvitationSetting: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)(actionType.GET_INVITATION_SETTING, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, _data, _$error, message, data;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_setting__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getInvitationSetting */ .ZP.getInvitationSetting();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get invitation setting failed");
                case 6:
                    _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                    if (!_$error) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        error: _$error,
                        message: message
                    });
                case 9:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }))),
    updateInvitationSetting: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)(actionType.UPDATE_INVITATION_SETTING, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(groupSetting) {
            var requestPayload, response, _data, _$error, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        requestPayload = {
                            group_setting: groupSetting
                        };
                        _ctx.next = 4;
                        return lib_api_setting__WEBPACK_IMPORTED_MODULE_3__/* ["default"].updateInvitationSetting */ .ZP.updateInvitationSetting(requestPayload);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to update invitation setting failed");
                    case 7:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }));
        return function(groupSetting) {
            return _ref.apply(this, arguments);
        };
    }()),
    getBlacklistStatus: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)(actionType.GET_BLOCKLIST_STATUS, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, _data, _$error, error_type, message, data;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_friends__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getBlacklistStatus */ .Z.getBlacklistStatus();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get blacklist status failed");
                case 6:
                    _data = response.data, _$error = _data.error, error_type = _data.error_type, message = _data.message, data = _data.data;
                    if (!(_$error || error_type)) {
                        _ctx.next = 9;
                        break;
                    }
                    throw new Error(message);
                case 9:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }))),
    updateBlacklistStatus: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)(actionType.UPDATE_BLOCKLIST_STATUS, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, _data, _$error, error_type, message, data;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_friends__WEBPACK_IMPORTED_MODULE_4__/* ["default"].updateBlacklistStatus */ .Z.updateBlacklistStatus();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to set blacklist status failed");
                case 6:
                    _data = response.data, _$error = _data.error, error_type = _data.error_type, message = _data.message, data = _data.data;
                    if (!(_$error || error_type)) {
                        _ctx.next = 9;
                        break;
                    }
                    throw new Error(message);
                case 9:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    })))
};
var extraReducers = function(builder) {
    builder.addCase(effects.getChangePasswordToken.pending, function(state) {
        state.getChangePasswordToken.isLoading = true;
        state.getChangePasswordToken.error = null;
    }).addCase(effects.getChangePasswordToken.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        if (error) {
            state.getChangePasswordToken.error = error;
        } else {
            state.getChangePasswordToken.data = data;
        }
        state.getChangePasswordToken.message = message;
        state.getChangePasswordToken.isLoading = false;
    }).addCase(effects.getChangePasswordToken.rejected, function(state, action) {
        state.getChangePasswordToken.isLoading = false;
        state.getChangePasswordToken.error = action.payload.error;
    }).addCase(effects.updatePassword.pending, function(state) {
        state.updatePassword.isLoading = true;
        state.updatePassword.error = null;
    }).addCase(effects.updatePassword.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        if (error) {
            state.updatePassword.error = error;
        } else {
            state.updatePassword.data = data;
        }
        state.updatePassword.message = message;
        state.updatePassword.isLoading = false;
    }).addCase(effects.updatePassword.rejected, function(state, action) {
        state.updatePassword.isLoading = false;
        state.updatePassword.error = action.payload.error;
    })// update discoverable privacy doesn't affect reducer
    .addCase(effects.getBlockedUsers.pending, function(state, action) {
        state.blockedUsers.isLoading = true;
        state.blockedUsers.error = null;
        // reset list
        if (action.meta.arg === 1) {
            state.blockedUsers.data = initialState.blockedUsers.data;
        }
    }).addCase(effects.getBlockedUsers.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message, more = _payload.more;
        if (error) {
            state.blockedUsers.error = error;
        } else {
            var _data;
            (_data = state.blockedUsers.data).push.apply(_data, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(data));
            state.blockedUsers.isLastPage = !more;
        }
        state.blockedUsers.isLoading = false;
        state.blockedUsers.message = message;
    }).addCase(effects.getBlockedUsers.rejected, function(state, action) {
        state.blockedUsers.error = action.payload.error;
        state.blockedUsers.isLoading = false;
    })// only handle if unblock success
    .addCase(effects.unblockUser.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, userid = _payload.userid;
        if (!error) {
            var newUserList = state.blockedUsers.data.filter(function(user) {
                return user.user_id !== userid;
            });
            state.blockedUsers.data = newUserList;
        }
    }).addCase(effects.getNotifications.pending, function(state) {
        state.notifications.isLoading = true;
        state.notifications.error = null;
    }).addCase(effects.getNotifications.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data;
        if (error) {
            state.notifications.error = error;
        } else {
            state.notifications.data = data;
        }
        state.notifications.message = message;
        state.notifications.isLoading = false;
    }).addCase(effects.getNotifications.rejected, function(state, action) {
        state.notifications.error = action.payload.error;
        state.notifications.isLoading = false;
    }).addCase(effects.updateNotification.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, dataUpdated = _payload.dataUpdated;
        if (error) {
            state.notifications.error = error;
        } else {
            state.notifications.data = dataUpdated;
        }
    }).addCase(effects.changeAvatar.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error;
        if (!error) {
            state.changeAvatar.avatar = data;
        }
    }).addCase(effects.getTradingAccounts.pending, function(state) {
        state.tradingAccounts.isLoading = true;
        state.tradingAccounts.error = null;
    }).addCase(effects.getTradingAccounts.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error, message = _payload.message;
        if (error) {
            state.tradingAccounts.error = error;
        } else {
            state.tradingAccounts.data = data;
        }
        state.tradingAccounts.message = message;
        state.tradingAccounts.isLoading = false;
    }).addCase(effects.getTradingAccounts.rejected, function(state, action) {
        state.tradingAccounts.error = action.payload.error;
        state.tradingAccounts.isLoading = false;
    }).addCase(effects.unlinkTradingAccount.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, brokerKey = _payload.brokerKey;
        if (!error) {
            var ref, ref1;
            // @ts-ignore
            var brokerList = ((ref = state.tradingAccounts.data) === null || ref === void 0 ? void 0 : (ref1 = ref.brokers) === null || ref1 === void 0 ? void 0 : ref1.list) || [];
            var brokerIdx = brokerList.findIndex(function(broker) {
                return broker.key === brokerKey;
            });
            if (brokerIdx > -1) {
                // @ts-ignore
                state.tradingAccounts.data.brokers.list[brokerIdx].link = null;
            }
        }
    }).addCase(effects.getAvatar3DList.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error, message = _payload.message;
        if (error) {
            state.avatar3DList.error = error;
        } else {
            state.avatar3DList.data = data;
        }
        state.avatar3DList.message = message;
        state.avatar3DList.isLoading = false;
    }).addCase(effects.getInvitationSetting.pending, function(state) {
        state.invitationSetting.isLoading = true;
        state.invitationSetting.error = null;
    }).addCase(effects.getInvitationSetting.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        if (error) {
            state.invitationSetting.error = error;
        } else {
            state.invitationSetting.data = data;
        }
        state.invitationSetting.message = message;
        state.invitationSetting.isLoading = false;
    }).addCase(effects.getInvitationSetting.rejected, function(state, action) {
        state.invitationSetting.isLoading = false;
        state.invitationSetting.error = action.payload.error;
    }).addCase(effects.updateInvitationSetting.pending, function(state) {
        state.invitationSetting.isLoading = true;
        state.invitationSetting.error = null;
    }).addCase(effects.updateInvitationSetting.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        if (error) {
            state.invitationSetting.error = error;
        } else {
            state.invitationSetting.data = data;
        }
        state.invitationSetting.message = message;
        state.invitationSetting.isLoading = false;
    }).addCase(effects.updateInvitationSetting.rejected, function(state, action) {
        state.invitationSetting.isLoading = false;
        state.invitationSetting.error = action.payload.error;
    }).addCase(effects.getBlacklistStatus.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        if (!error) {
            state.blacklistStatus.status = data.status;
        }
        state.blacklistStatus.message = message;
    }).addCase(effects.updateBlacklistStatus.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        if (!error) {
            state.blacklistStatus.status = data.status;
        }
        state.blacklistStatus.message = message;
    });
};
var editProfileSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createSlice */ .oM)({
    name: "editProfile",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (editProfileSlice);


/***/ }),

/***/ 41351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BT": function() { return /* binding */ DATA_CY_NAME_STREAM_SUB_HEADER_REPORT; },
/* harmony export */   "D6": function() { return /* binding */ DATA_CY_USER_CATEGORY_IDEAS; },
/* harmony export */   "EJ": function() { return /* binding */ DATA_CY_NAME_NEWS_HEADER_MENU; },
/* harmony export */   "En": function() { return /* binding */ DATA_CY_USER_CATEGORY_CHARTS; },
/* harmony export */   "Js": function() { return /* binding */ DATA_CY_DROPDOWN_STREAM_TYPE_ALL; },
/* harmony export */   "LO": function() { return /* binding */ DATA_CY_USER_CATEGORY_SAVED; },
/* harmony export */   "MF": function() { return /* binding */ DATA_CY_DROPDOWN_STREAM_ACTIVE; },
/* harmony export */   "Me": function() { return /* binding */ DATA_CY_USER_CATEGORY_LIKED; },
/* harmony export */   "N5": function() { return /* binding */ DATA_CY_DROPDOWN_STREAM_TYPE_TRENDING; },
/* harmony export */   "Nd": function() { return /* binding */ DATA_CY_NAME_STREAM_SUB_HEADER_POLLING_COMPANY; },
/* harmony export */   "OR": function() { return /* binding */ DATA_CY_DROPDOWN_STREAM_TYPE_FOLLOWED; },
/* harmony export */   "Ox": function() { return /* binding */ DATA_CY_SEARCH_STREAM_FILTER_FROM; },
/* harmony export */   "Ps": function() { return /* binding */ DATA_CY_DROPDOWN_STREAM_TYPE_ALL_COMPANY; },
/* harmony export */   "SP": function() { return /* binding */ DATA_CY_USER_CATEGORY_NOTES; },
/* harmony export */   "Tb": function() { return /* binding */ DATA_CY_NAME_NOTES_MENU_COMPANY; },
/* harmony export */   "UL": function() { return /* binding */ DATA_CY_SEARCH_STREAM_MENU_SEARCH; },
/* harmony export */   "Ys": function() { return /* binding */ DATA_CY_NAME_STREAM_SUB_HEADER_PREDICTION; },
/* harmony export */   "Zl": function() { return /* binding */ DATA_CY_NAME_STREAM_HEADER_MENU; },
/* harmony export */   "_t": function() { return /* binding */ DATA_CY_NAME_RESEARCH_HEADER_MENU; },
/* harmony export */   "b7": function() { return /* binding */ DATA_CY_NAME_STREAM_SUB_HEADER_INSIDER_COMPANY; },
/* harmony export */   "bJ": function() { return /* binding */ DATA_CY_SEARCH_STREAM_FILTER_TO; },
/* harmony export */   "c6": function() { return /* binding */ DATA_CY_NAME_STREAM_SUB_HEADER_CHART_COMPANY; },
/* harmony export */   "dV": function() { return /* binding */ DATA_CY_NAME_STREAM_SUB_HEADER_INSIDER; },
/* harmony export */   "ed": function() { return /* binding */ DATA_CY_NAME_STREAM_SUB_HEADER_POLLING; },
/* harmony export */   "gJ": function() { return /* binding */ DATA_CY_DROPDOWN_STREAM_TYPE_WATCHLIST; },
/* harmony export */   "gz": function() { return /* binding */ DATA_CY_NAME_STREAM_SUB_HEADER_REPORT_COMPANY; },
/* harmony export */   "h$": function() { return /* binding */ DATA_CY_SEARCH_STREAM_SUBMIT; },
/* harmony export */   "hL": function() { return /* binding */ DATA_CY_SEARCH_STREAM_MENU; },
/* harmony export */   "je": function() { return /* binding */ DATA_CY_NAME_STREAM_SUB_HEADER_IDEA; },
/* harmony export */   "kk": function() { return /* binding */ DATA_CY_NAME_NEWS_HEADER_MENU_COMPANY; },
/* harmony export */   "lJ": function() { return /* binding */ DATA_CY_DROPDOWN_STREAM_TYPE_PEOPLE; },
/* harmony export */   "p2": function() { return /* binding */ DATA_CY_NAME_STREAM_SUB_HEADER_IDEA_COMPANY; },
/* harmony export */   "sQ": function() { return /* binding */ DATA_CY_NAME_RESEARCH_HEADER_MENU_COMPANY; },
/* harmony export */   "tG": function() { return /* binding */ DATA_CY_USER_CATEGORY_REPLIES; },
/* harmony export */   "tx": function() { return /* binding */ DATA_CY_SEARCH_STREAM_MENU_FILTER; },
/* harmony export */   "v6": function() { return /* binding */ DATA_CY_NAME_STREAM_SUB_HEADER_CHART; },
/* harmony export */   "wv": function() { return /* binding */ DATA_CY_NAME_STREAM_SUB_HEADER_PREDICTION_COMPANY; },
/* harmony export */   "xB": function() { return /* binding */ DATA_CY_DROPDOWN_STREAM_REPORT_ACTIVE; },
/* harmony export */   "zc": function() { return /* binding */ DATA_CY_USER_CATEGORY_PREDICTIONS; }
/* harmony export */ });
/* unused harmony exports DATA_CY_NAME_STREAM_HEADER_MENU_COMPANY, DATA_CY_SEARCH_STREAM_MENU_FILTER_COMPANY, DATA_CY_SEARCH_STREAM_MENU_SEARCH_COMPANY, DATA_CY_SEARCH_STREAM_FILTER_FROM_COMPANY, DATA_CY_SEARCH_STREAM_FILTER_TO_COMPANY, DATA_CY_SEARCH_STREAM_SUBMIT_COMPANY, DATA_CY_DROPDOWN_STREAM_TYPE_TRENDING_COMPANY, DATA_CY_DROPDOWN_STREAM_TYPE_FOLLOWED_COMPANY, DATA_CY_DROPDOWN_STREAM_TYPE_PEOPLE_COMPANY, DATA_CY_DROPDOWN_STREAM_TYPE_WATCHLIST_COMPANY */
var DATA_CY_NAME_STREAM_HEADER_MENU = "stream-header-menu";
var DATA_CY_NAME_STREAM_SUB_HEADER_IDEA = "stream-sub-header-idea";
var DATA_CY_NAME_STREAM_SUB_HEADER_REPORT = "stream-sub-header-reports";
var DATA_CY_NAME_STREAM_SUB_HEADER_PREDICTION = "stream-sub-header-predictions";
var DATA_CY_NAME_STREAM_SUB_HEADER_POLLING = "stream-sub-header-polling";
var DATA_CY_NAME_STREAM_SUB_HEADER_INSIDER = "stream-sub-header-insiders";
var DATA_CY_NAME_STREAM_SUB_HEADER_CHART = "stream-sub-header-charts";
var DATA_CY_NAME_NEWS_HEADER_MENU = "news-header-menu";
var DATA_CY_NAME_RESEARCH_HEADER_MENU = "research-header-menu";
var DATA_CY_SEARCH_STREAM_MENU_FILTER = "search-stream-menu-filter";
var DATA_CY_SEARCH_STREAM_MENU = "search-stream-menu";
var DATA_CY_SEARCH_STREAM_MENU_SEARCH = "search-stream-menu-search";
var DATA_CY_SEARCH_STREAM_FILTER_FROM = "search-stream-filter-from";
var DATA_CY_SEARCH_STREAM_FILTER_TO = "search-stream-filter-to";
var DATA_CY_SEARCH_STREAM_SUBMIT = "search-stream-submit";
var DATA_CY_DROPDOWN_STREAM_ACTIVE = "dropdown-stream-active";
var DATA_CY_DROPDOWN_STREAM_TYPE_ALL = "dropdown-stream-type-all";
var DATA_CY_DROPDOWN_STREAM_TYPE_TRENDING = "dropdown-stream-type-trending";
var DATA_CY_DROPDOWN_STREAM_TYPE_FOLLOWED = "dropdown-stream-type-followed";
var DATA_CY_DROPDOWN_STREAM_TYPE_PEOPLE = "dropdown-stream-type-people";
var DATA_CY_DROPDOWN_STREAM_TYPE_WATCHLIST = "dropdown-stream-type-watchlist";
var DATA_CY_NAME_STREAM_HEADER_MENU_COMPANY = "stream-header-menu-company";
var DATA_CY_NAME_STREAM_SUB_HEADER_IDEA_COMPANY = "stream-sub-header-idea-company";
var DATA_CY_NAME_STREAM_SUB_HEADER_REPORT_COMPANY = "stream-sub-header-reports-company";
var DATA_CY_NAME_STREAM_SUB_HEADER_PREDICTION_COMPANY = "stream-sub-header-predictions-company";
var DATA_CY_NAME_STREAM_SUB_HEADER_POLLING_COMPANY = "stream-sub-header-polling-company";
var DATA_CY_NAME_STREAM_SUB_HEADER_INSIDER_COMPANY = "stream-sub-header-insiders-company";
var DATA_CY_NAME_STREAM_SUB_HEADER_CHART_COMPANY = "stream-sub-header-charts-company";
var DATA_CY_NAME_NEWS_HEADER_MENU_COMPANY = "news-header-menu-company";
var DATA_CY_NAME_NOTES_MENU_COMPANY = "stream-notes-compose-company";
var DATA_CY_NAME_RESEARCH_HEADER_MENU_COMPANY = "research-header-menu-company";
var DATA_CY_SEARCH_STREAM_MENU_FILTER_COMPANY = "search-stream-menu-filter-company";
var DATA_CY_SEARCH_STREAM_MENU_SEARCH_COMPANY = "search-stream-menu-search-company";
var DATA_CY_SEARCH_STREAM_FILTER_FROM_COMPANY = "search-stream-filter-from-company";
var DATA_CY_SEARCH_STREAM_FILTER_TO_COMPANY = "search-stream-filter-to-company";
var DATA_CY_SEARCH_STREAM_SUBMIT_COMPANY = "search-stream-submit-company";
var DATA_CY_DROPDOWN_STREAM_TYPE_ALL_COMPANY = "dropdown-stream-type-all-company";
var DATA_CY_DROPDOWN_STREAM_TYPE_TRENDING_COMPANY = "dropdown-stream-type-trending-company";
var DATA_CY_DROPDOWN_STREAM_TYPE_FOLLOWED_COMPANY = "dropdown-stream-type-followed-company";
var DATA_CY_DROPDOWN_STREAM_TYPE_PEOPLE_COMPANY = "dropdown-stream-type-people-company";
var DATA_CY_DROPDOWN_STREAM_TYPE_WATCHLIST_COMPANY = "dropdown-stream-type-watchlist-company";
var DATA_CY_DROPDOWN_STREAM_REPORT_ACTIVE = "dropdown-stream-report-active";
var DATA_CY_USER_CATEGORY_IDEAS = "user-category-ideas";
var DATA_CY_USER_CATEGORY_REPLIES = "user-category-replies";
var DATA_CY_USER_CATEGORY_CHARTS = "user-category-charts";
var DATA_CY_USER_CATEGORY_LIKED = "user-category-liked";
var DATA_CY_USER_CATEGORY_SAVED = "user-category-saved";
var DATA_CY_USER_CATEGORY_PREDICTIONS = "user-category-predictions";
var DATA_CY_USER_CATEGORY_NOTES = "user-category-notes";


/***/ }),

/***/ 21390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DY": function() { return /* binding */ TAB_USER_CATEGORIES; },
/* harmony export */   "Hw": function() { return /* binding */ nonSourceNews; },
/* harmony export */   "J1": function() { return /* binding */ streamTypes; },
/* harmony export */   "OW": function() { return /* binding */ STREAM_REPORT; },
/* harmony export */   "PA": function() { return /* binding */ STREAM_TABS_MY; },
/* harmony export */   "R5": function() { return /* binding */ STREAM_TYPE; },
/* harmony export */   "Sb": function() { return /* binding */ DEFAULT_TYPE; },
/* harmony export */   "U1": function() { return /* binding */ reportCategories; },
/* harmony export */   "Z9": function() { return /* binding */ DEFAULT_HEADER; },
/* harmony export */   "bd": function() { return /* binding */ categories; },
/* harmony export */   "c$": function() { return /* binding */ reportOptions; },
/* harmony export */   "cT": function() { return /* binding */ stockChange; },
/* harmony export */   "eB": function() { return /* binding */ STREAM_STATE; },
/* harmony export */   "gd": function() { return /* binding */ MAX_TIPPING_AMOUNT; },
/* harmony export */   "hD": function() { return /* binding */ STREAM_VERSION; },
/* harmony export */   "oE": function() { return /* binding */ LS_STREAM_TRENDING_TAB_DATE; },
/* harmony export */   "oK": function() { return /* binding */ TAB_CATEGORIES; },
/* harmony export */   "q1": function() { return /* binding */ STREAM_TABS; }
/* harmony export */ });
/* unused harmony exports STREAM_CATEGORY_ENUM, STREAM_REPORT_TYPE_ENUM */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22147);
/* harmony import */ var _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41351);



var STREAM_TYPE = {
    GENERIC: "generic",
    USER: "user",
    SYMBOL: "symbol"
};
var genericCategories = [
    {
        label: "Ideas",
        key: "ideas",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_SUB_HEADER_IDEA */ .je
    },
    {
        label: "Reports",
        key: "reports",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_SUB_HEADER_REPORT */ .BT
    },
    {
        label: "Predictions",
        key: "predictions",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_SUB_HEADER_PREDICTION */ .Ys
    },
    {
        label: "Polling",
        key: "pollings",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_SUB_HEADER_POLLING */ .ed
    },
    {
        label: "Insiders",
        key: "insider",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_SUB_HEADER_INSIDER */ .dV
    },
    {
        label: "Charts",
        key: "charts",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_SUB_HEADER_CHART */ .v6
    }, 
];
var symbolCategories = [
    {
        label: "All",
        key: "all",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_DROPDOWN_STREAM_TYPE_ALL_COMPANY */ .Ps
    },
    {
        label: "Notes",
        key: "notes",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_NOTES_MENU_COMPANY */ .Tb
    },
    {
        label: "News",
        key: "news",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_NEWS_HEADER_MENU_COMPANY */ .kk
    },
    {
        label: "Reports",
        key: "reports",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_SUB_HEADER_REPORT_COMPANY */ .gz
    },
    {
        label: "Research",
        key: "research",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_RESEARCH_HEADER_MENU_COMPANY */ .sQ
    },
    {
        label: "Ideas",
        key: "ideas",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_SUB_HEADER_IDEA_COMPANY */ .p2
    },
    {
        label: "Predictions",
        key: "predictions",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_SUB_HEADER_PREDICTION_COMPANY */ .wv
    },
    {
        label: "Polling",
        key: "pollings",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_SUB_HEADER_POLLING_COMPANY */ .Nd
    },
    {
        label: "Insiders",
        key: "insider",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_SUB_HEADER_INSIDER_COMPANY */ .b7
    },
    {
        label: "Charts",
        key: "charts",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_SUB_HEADER_CHART_COMPANY */ .c6
    }, 
];
var userCategories = [
    {
        label: "Ideas",
        key: "main ideas",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_USER_CATEGORY_IDEAS */ .D6
    },
    {
        label: "Notes",
        key: "notes",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_USER_CATEGORY_NOTES */ .SP
    },
    {
        label: "Replies",
        key: "reply",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_USER_CATEGORY_REPLIES */ .tG
    },
    {
        label: "Charts",
        key: "charts",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_USER_CATEGORY_CHARTS */ .En
    },
    {
        label: "Liked",
        key: "liked",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_USER_CATEGORY_LIKED */ .Me
    },
    {
        label: "Saved",
        key: "saved",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_USER_CATEGORY_SAVED */ .LO
    },
    {
        label: "Predictions",
        key: "predictions",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_USER_CATEGORY_PREDICTIONS */ .zc
    }, 
];
var _obj;
var categories = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, STREAM_TYPE.GENERIC, genericCategories), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, STREAM_TYPE.SYMBOL, symbolCategories), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, STREAM_TYPE.USER, userCategories), _obj);
var streamTypes = [
    {
        label: "Trending",
        key: "trending",
        lsKey: "trending",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_DROPDOWN_STREAM_TYPE_TRENDING */ .N5
    },
    {
        label: "Followed",
        key: "all watchlist",
        lsKey: "following",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_DROPDOWN_STREAM_TYPE_FOLLOWED */ .OR
    },
    {
        label: "All",
        key: "latest",
        lsKey: "latest",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_DROPDOWN_STREAM_TYPE_ALL */ .Js
    },
    {
        label: "People",
        key: "people watchlist",
        lsKey: "following_people",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_DROPDOWN_STREAM_TYPE_PEOPLE */ .lJ
    },
    {
        label: "Watchlist",
        key: "company watchlist",
        lsKey: "following_company",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_DROPDOWN_STREAM_TYPE_WATCHLIST */ .gJ
    }, 
];
var reportCategories = [
    {
        label: "All",
        key: "all"
    },
    {
        label: "Laporan Keuangan",
        key: "laporan_keuangan"
    },
    {
        label: "RUPS/Public Expose",
        key: "rups"
    },
    {
        label: "Kepemilikan Saham",
        key: "kepemilikan_saham"
    },
    {
        label: "Dividend",
        key: "dividend"
    },
    {
        label: "Corporate Action",
        key: "corporate_action"
    },
    {
        label: "Others",
        key: "others"
    }, 
];
var reportOptions = [
    {
        key: "1",
        label: "Improper Use of $ Tag"
    },
    {
        key: "2",
        label: "Incorrect Writing Standard"
    },
    {
        key: "3",
        label: "Advertising"
    },
    {
        key: "4",
        label: "Junk Post"
    },
    {
        key: "5",
        label: "Spam"
    },
    {
        key: "6",
        label: "Out of Topic"
    },
    {
        key: "7",
        label: "Vulgarity"
    },
    {
        key: "8",
        label: "Abusive Behaviour"
    },
    {
        key: "9",
        label: "Provoking Other Users"
    },
    {
        key: "10",
        label: "Inapropriate Username & Photo"
    },
    {
        key: "11",
        label: "Stocks Cheering"
    }, 
];
var stockChange = {
    netral: {
        icon: "",
        color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_0__/* ["default"].nobel */ .Z.nobel
    },
    up: {
        icon: "icon-symbol_up",
        color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_0__/* ["default"].primary */ .Z.primary
    },
    down: {
        icon: "icon-symbol_down",
        color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_0__/* ["default"].sunsetOrange */ .Z.sunsetOrange
    }
};
var STREAM_STATE = {
    CATEGORY: "stbx-active-stream-filter",
    TYPE: "stbx-active-stream",
    TAB: "stbx-active-stream-header"
};
var nonSourceNews = {
    stockbitnews: {
        username: "StockbitNews",
        label: "Stockbit News",
        extend: true,
        image: "/img/sbnewsicon.png"
    },
    klsenews: {
        username: "KLSEnews",
        label: "KLSENews",
        extend: false,
        image: "/img/sbnewsicon.png"
    }
};
var STREAM_TABS = [
    {
        label: "Stream",
        value: "stream",
        icon: "/icon/stream-filter/header-stream",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_HEADER_MENU */ .Zl
    },
    {
        label: "News",
        value: "news",
        icon: "/icon/stream-filter/header-news",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_NEWS_HEADER_MENU */ .EJ
    },
    {
        label: "Research",
        value: "research",
        icon: "/icon/stream-filter/header-research",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_RESEARCH_HEADER_MENU */ ._t
    }, 
];
var STREAM_TABS_MY = [
    {
        label: "Stream",
        value: "stream",
        icon: "/icon/stream-filter/header-stream",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_HEADER_MENU */ .Zl
    }, 
];
var DEFAULT_TYPE = "ideas";
var DEFAULT_HEADER = "stream";
var MAX_TIPPING_AMOUNT = 10000000;
var LS_STREAM_TRENDING_TAB_DATE = "stbx-active-trending-date";
// Constants for stream v3 (general, company, user)
var STREAM_VERSION = {
    DEFAULT: "exodus",
    V3: "exodus_v3"
};
var STREAM_CATEGORY_ENUM = {
    ALL: "STREAM_CATEGORY_ALL",
    ALL_WATCHLIST: "STREAM_CATEGORY_ALL_WATCHLIST",
    PEOPLE_WATCHLIST: "STREAM_CATEGORY_PEOPLE_WATCHLIST",
    COMPANY_WATCHLIST: "STREAM_CATEGORY_COMPANY_WATCHLIST",
    NEWS: "STREAM_CATEGORY_NEWS",
    CHART: "STREAM_CATEGORY_CHART",
    CHARTS: "STREAM_CATEGORY_CHART",
    REPORTS: "STREAM_CATEGORY_REPORTS",
    IDEAS: "STREAM_CATEGORY_IDEAS",
    INSIDER: "STREAM_CATEGORY_INSIDER",
    PREDICTION: "STREAM_CATEGORY_PREDICTION",
    PREDICTIONS: "STREAM_CATEGORY_PREDICTION",
    POLLING: "STREAM_CATEGORY_POLLING",
    POLLINGS: "STREAM_CATEGORY_POLLING",
    REPLY: "STREAM_CATEGORY_REPLY",
    MAIN_IDEAS: "STREAM_CATEGORY_MAIN_IDEAS",
    LIKED: "STREAM_CATEGORY_LIKED",
    SAVED: "STREAM_CATEGORY_SAVED",
    RESEARCH: "research"
};
var TAB_CATEGORIES = {
    all: STREAM_CATEGORY_ENUM.ALL,
    ideas: STREAM_CATEGORY_ENUM.IDEAS,
    news: STREAM_CATEGORY_ENUM.NEWS,
    reports: STREAM_CATEGORY_ENUM.REPORTS,
    charts: STREAM_CATEGORY_ENUM.CHART,
    insider: STREAM_CATEGORY_ENUM.INSIDER,
    predictions: STREAM_CATEGORY_ENUM.PREDICTION,
    pollings: STREAM_CATEGORY_ENUM.POLLING,
    latest: STREAM_CATEGORY_ENUM.IDEAS,
    "all watchlist": STREAM_CATEGORY_ENUM.ALL_WATCHLIST,
    "people watchlist": STREAM_CATEGORY_ENUM.PEOPLE_WATCHLIST,
    "company watchlist": STREAM_CATEGORY_ENUM.COMPANY_WATCHLIST
};
var TAB_USER_CATEGORIES = {
    "main ideas": STREAM_CATEGORY_ENUM.MAIN_IDEAS,
    reply: STREAM_CATEGORY_ENUM.REPLY,
    charts: STREAM_CATEGORY_ENUM.CHART,
    liked: STREAM_CATEGORY_ENUM.LIKED,
    saved: STREAM_CATEGORY_ENUM.SAVED,
    predictions: STREAM_CATEGORY_ENUM.PREDICTIONS
};
var STREAM_REPORT_TYPE_ENUM = {
    OTHER: "REPORT_TYPE_OTHER",
    LAPORAN_KEUANGAN: "REPORT_TYPE_LAPORAN_KEUANGAN",
    RUPS: "REPORT_TYPE_RUPS",
    KEPIMILIKAN_SAHAM: "REPORT_TYPE_KEPIMILIKAN_SAHAM",
    DIVIDEN: "REPORT_TYPE_DIVIDEN",
    CORPORATE_ACTION: "REPORT_TYPE_CORPORATE_ACTION",
    ALL: "REPORT_TYPE_ALL"
};
var STREAM_REPORT = {
    all: STREAM_REPORT_TYPE_ENUM.ALL,
    laporan_keuangan: STREAM_REPORT_TYPE_ENUM.LAPORAN_KEUANGAN,
    rups: STREAM_REPORT_TYPE_ENUM.RUPS,
    kepemilikan_saham: STREAM_REPORT_TYPE_ENUM.KEPIMILIKAN_SAHAM,
    dividend: STREAM_REPORT_TYPE_ENUM.DIVIDEN,
    corporate_action: STREAM_REPORT_TYPE_ENUM.CORPORATE_ACTION,
    others: STREAM_REPORT_TYPE_ENUM.OTHER
};



/***/ }),

/***/ 63699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37213);
/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68425);
/* harmony import */ var features_discover_people_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28635);
/* eslint-disable import/named */ 


var requestExodus = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
var suggestionURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_0__/* .API_EXODUS_URL */ .q7, "/friend-discovery/suggestions");
var FRIEND_DISCOVERY = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_0__/* .API_EXODUS_URL */ .q7, "/friend-discovery");
var getSuggestFriends = function(config) {
    var limit = config.limit, page = config.page, _filter = config.filter, filter = _filter === void 0 ? 0 : _filter;
    return requestExodus.get("".concat(suggestionURL, "/query"), {
        params: {
            limit: limit,
            page: page,
            filter: filter
        }
    });
};
var getSuggestFriendsContacts = function(limit, page) {
    return requestExodus.get("".concat(suggestionURL, "/contacts"), {
        params: {
            limit: limit,
            page: page
        }
    });
};
var getBlacklistStatus = function() {
    return requestExodus.get("".concat(FRIEND_DISCOVERY, "/contacts/discoverable"));
};
var updateBlacklistStatus = function() {
    return requestExodus.post("".concat(FRIEND_DISCOVERY, "/contacts/discoverable"));
};
var getContactSyncStatus = function() {
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_0__/* .API_EXODUS_URL */ .q7, "/friend-discovery/contacts/status"));
};
var getFollowedBy = function(params) {
    return requestExodus.get("".concat(FRIEND_DISCOVERY, "/followed-by"), {
        params: params
    });
};
var getTrending = function() {
    var timeframe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : features_discover_people_types__WEBPACK_IMPORTED_MODULE_2__/* .TrendingTimeFrame.ALL */ .b.ALL, limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100, cursor = arguments.length > 2 ? arguments[2] : void 0;
    return requestExodus.get("user/v2/discovery/trending", {
        params: {
            time_frame: timeframe,
            limit: limit,
            cursor: cursor
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getSuggestFriends: getSuggestFriends,
    getSuggestFriendsContacts: getSuggestFriendsContacts,
    getBlacklistStatus: getBlacklistStatus,
    updateBlacklistStatus: updateBlacklistStatus,
    getContactSyncStatus: getContactSyncStatus,
    getFollowedBy: getFollowedBy,
    getTrending: getTrending
});


/***/ }),

/***/ 45621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PC": function() { return /* binding */ loginType; },
/* harmony export */   "vO": function() { return /* binding */ deviceType; }
/* harmony export */ });
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37213);
/* harmony import */ var lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78372);


var requestExodusDefault = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__/* ["default"].defaultInstance */ .Z.defaultInstance;
var requestExodus = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__/* ["default"].noAlert */ .Z.noAlert;
var USER_SETTING_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_0__/* .API_EXODUS_URL */ .q7, "/user/setting");
var INVITATION_SETTING_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_0__/* .API_EXODUS_URL */ .q7, "/chat/v2/invitations/setting");
var NOTIFICATION_SETTING_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_0__/* .API_EXODUS_URL */ .q7, "/notification/settings");
var NOTIF_V2_SETTING_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_0__/* .API_EXODUS_URL */ .q7, "/notification/v2/settings");
var deviceType;
(function(deviceType) {
    deviceType["DEVICE_TYPE_UNSPECIFIED"] = "DEVICE_TYPE_UNSPECIFIED";
    deviceType["DEVICE_TYPE_ANDROID"] = "DEVICE_TYPE_ANDROID";
    deviceType["DEVICE_TYPE_IOS"] = "DEVICE_TYPE_IOS";
    deviceType["DEVICE_TYPE_WEB"] = "DEVICE_TYPE_WEB";
    deviceType["DEVICE_TYPE_DESKTOP"] = "DEVICE_TYPE_DESKTOP";
})(deviceType || (deviceType = {}));
var loginType;
(function(loginType) {
    loginType["LOGIN_TYPE_UNSPECIFIED"] = "LOGIN_TYPE_UNSPECIFIED";
    loginType["LOGIN_TYPE_BY_USERNAME"] = "LOGIN_TYPE_BY_USERNAME";
    loginType["LOGIN_TYPE_BY_GOOGLE"] = "LOGIN_TYPE_BY_GOOGLE";
    loginType["LOGIN_TYPE_BY_FACEBOOK"] = "LOGIN_TYPE_BY_FACEBOOK";
    loginType["LOGIN_TYPE_BY_APPLE"] = "LOGIN_TYPE_BY_APPLE";
    loginType["LOGIN_TYPE_BY_TOUCHID"] = "LOGIN_TYPE_BY_TOUCHID";
    loginType["LOGIN_TYPE_BY_SSO"] = "LOGIN_TYPE_BY_SSO";
    loginType["LOGIN_TYPE_BY_USER_KEY"] = "LOGIN_TYPE_BY_USER_KEY";
})(loginType || (loginType = {}));
var getChangePasswordToken = function(data) {
    return requestExodusDefault.post("".concat(USER_SETTING_URL, "/token"), data);
};
var updatePassword = function(data) {
    return requestExodusDefault.put("".concat(USER_SETTING_URL, "/password"), data);
};
var getNotificationSettings = function() {
    return requestExodusDefault.get("".concat(NOTIF_V2_SETTING_URL));
};
var updateNotificationSetting = function(data) {
    return requestExodus.put("".concat(NOTIFICATION_SETTING_URL), data);
};
var getInvitationSetting = function() {
    return requestExodus.get("".concat(INVITATION_SETTING_URL));
};
var updateInvitationSetting = function(data) {
    return requestExodusDefault.put("".concat(INVITATION_SETTING_URL), data);
};
// Update email
var updateEmail = function(data) {
    return requestExodusDefault.post("".concat(USER_SETTING_URL, "/email"), data);
};
var confirmEmailOTP = function(data) {
    return requestExodusDefault.post("".concat(USER_SETTING_URL, "/email/confirm"), data);
};
// Update phone
var updatePhone = function(data) {
    return requestExodusDefault.post("".concat(USER_SETTING_URL, "/phone"), data);
};
var confirmPhoneOTP = function(data) {
    return requestExodusDefault.post("".concat(USER_SETTING_URL, "/phone/confirm"), data);
};
var getDeviceList = function() {
    return requestExodus.get("/auth/session/devices");
};
var removeDevice = function(props) {
    return requestExodusDefault.post("/auth/session/device/".concat(props.uuid, "/remove"), {
        password: props.password
    });
};

/* harmony default export */ __webpack_exports__["ZP"] = ({
    getChangePasswordToken: getChangePasswordToken,
    updatePassword: updatePassword,
    getNotificationSettings: getNotificationSettings,
    updateNotificationSetting: updateNotificationSetting,
    getInvitationSetting: getInvitationSetting,
    updateInvitationSetting: updateInvitationSetting,
    updateEmail: updateEmail,
    confirmEmailOTP: confirmEmailOTP,
    updatePhone: updatePhone,
    confirmPhoneOTP: confirmPhoneOTP,
    getDeviceList: getDeviceList,
    removeDevice: removeDevice
});


/***/ }),

/***/ 51679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78372);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37213);
/* harmony import */ var global_StreamWidget_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21390);
/* harmony import */ var utils_stream__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14601);
/** @typedef {import('../../../@types/api-response').APIResponse} APIResponse */ /* eslint-disable camelcase */ 





var requestExodus = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__/* ["default"].defaultInstance */ .Z.defaultInstance;
var requestExodusNoAlert = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__/* ["default"].noAlert */ .Z.noAlert;
// TODO: Change exodus url to stream url later on after every `/stream` path is migrated and tested
var STREAM_EXODUS_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/stream");
var STREAM_EXODUS_V3_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/stream/v3");
var STREAM_UPLOAD_TOKEN = "".concat(STREAM_EXODUS_URL, "/uploadtoken");
var STREAM_UPLOAD_TOKEN_V2 = "".concat(STREAM_EXODUS_URL, "/upload-tokens");
// Stockbit Stream -------------------------------------------------------------
/**
 * like stream post
 * @param {string} postid - post id
 * @returns {APIResponse}
 */ var likeStreamPost = function(postid) {
    return requestExodusNoAlert.post("".concat(STREAM_EXODUS_URL, "/like/").concat(postid));
};
/**
 * unlike stream post
 * @param {string} postid - post id
 * @returns {APIResponse}
 */ var unlikeStreamPost = function(postid) {
    return requestExodusNoAlert.post("".concat(STREAM_EXODUS_URL, "/unlike/").concat(postid));
};
/**
 *
 * @param {number=} version
 *
 * @param {Object} param
 * @param {number=} param.clean
 * @param {number=} param.beforelastpost
 * @param {string=} param.category
 * @param {number=} param.lastpost
 * @param {*=} param.keyword
 * @param {number=} param.limit
 * @param {string=} param.from
 * @param {string=} param.to
 * @param {string=} param.beforetimestamp
 * @returns {APIResponse}
 */ var getStream = function() {
    var version = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : global_StreamWidget_constants__WEBPACK_IMPORTED_MODULE_3__/* .STREAM_VERSION.V3 */ .hD.V3, ref = arguments.length > 1 ? arguments[1] : void 0, _clean = ref.clean, clean = _clean === void 0 ? 0 : _clean, _beforelastpost = ref.beforelastpost, beforelastpost = _beforelastpost === void 0 ? 0 : _beforelastpost, _category = ref.category, category = _category === void 0 ? "all" : _category, _lastpost = ref.lastpost, lastpost = _lastpost === void 0 ? 0 : _lastpost, keyword = ref.keyword, _limit = ref.limit, limit = _limit === void 0 ? 20 : _limit, _type = ref.type, type = _type === void 0 ? "latest" : _type, _from = ref.from, from = _from === void 0 ? "" : _from, _to = ref.to, to = _to === void 0 ? "" : _to, _beforetimestamp = ref.beforetimestamp, beforetimestamp = _beforetimestamp === void 0 ? null : _beforetimestamp, _date = ref.date, date = _date === void 0 ? moment__WEBPACK_IMPORTED_MODULE_0___default()(new Date()).format("YYYY-MM-DD") : _date, _page = ref.page, page = _page === void 0 ? 1 : _page, _reporttype = ref.reporttype, reporttype = _reporttype === void 0 ? "" : _reporttype;
    var params = {
        clean: clean,
        beforelastpost: beforelastpost,
        category: category,
        lastpost: lastpost,
        keyword: keyword,
        limit: limit,
        from: from,
        to: to,
        beforetimestamp: beforetimestamp
    };
    var streamURL = STREAM_EXODUS_V3_URL;
    if (type === "latest") {
        params.category = category;
        if (category === "reports") {
            params.reporttype = reporttype;
        }
    } else if (type === "trending" && !keyword) {
        streamURL = "".concat(streamURL, "/trending");
        params = {
            date: date,
            page: page,
            limit: limit
        };
    } else {
        // For non Ideas Filter will have type 'ideas', use category as category
        // For Ideas with non 'All' filter, use type as category
        if (type === "ideas") {
            params.category = category;
        } else if (type === "trending" && keyword) {
            params.category = category;
        } else {
            params.category = type;
        }
        // Only report category has reporttype
        if (category === "reports") {
            params.reporttype = reporttype;
        } else {
            params.filter = "all";
        }
    }
    // Cleanup params with empty value
    params = (0,utils_stream__WEBPACK_IMPORTED_MODULE_4__/* .cleanupStreamPayload */ .Hm)(params);
    var body = {};
    if (type !== "trending" || keyword) {
        body = {
            category: global_StreamWidget_constants__WEBPACK_IMPORTED_MODULE_3__/* .TAB_CATEGORIES */ .oK[params.category],
            last_stream_id: lastpost,
            last_reply: beforetimestamp,
            keyword: keyword,
            from_date: from,
            to_date: to,
            limit: limit
        };
        if (params.reporttype) {
            // eslint-disable-next-line dot-notation
            body["report_type"] = global_StreamWidget_constants__WEBPACK_IMPORTED_MODULE_3__/* .STREAM_REPORT */ .OW[params.reporttype];
        }
    } else if (type === "trending" && !keyword) {
        body = {
            date: date,
            last_stream_id: lastpost,
            limit: limit
        };
    }
    body = (0,utils_stream__WEBPACK_IMPORTED_MODULE_4__/* .cleanupStreamPayload */ .Hm)(body);
    return requestExodus.post(streamURL, body);
};
/**
 * Get user stream data
 * @param {string} username
 *
 * @param {Object} param
 * @param {number} param.beforelastpost
 * @param {string} param.category
 * @param {number} param.lastpost
 * @param {*} param.keyword
 * @param {number} param.limit
 * @param {string} param.from
 * @param {string} param.to
 * @returns {APIResponse}
 */ var getUserStream = function(username, param) {
    var _category = param.category, category = _category === void 0 ? "all" : _category, _lastpost = param.lastpost, lastpost = _lastpost === void 0 ? 0 : _lastpost, keyword = param.keyword, _limit = param.limit, limit = _limit === void 0 ? 20 : _limit, _from = param.from, from = _from === void 0 ? "" : _from, _to = param.to, to = _to === void 0 ? "" : _to;
    var streamURL = "".concat(STREAM_EXODUS_V3_URL, "/user");
    var body = {
        category: global_StreamWidget_constants__WEBPACK_IMPORTED_MODULE_3__/* .TAB_USER_CATEGORIES */ .DY[category],
        last_stream_id: lastpost,
        keyword: keyword,
        from_date: from,
        to_date: to,
        limit: limit
    };
    body = (0,utils_stream__WEBPACK_IMPORTED_MODULE_4__/* .cleanupStreamPayload */ .Hm)(body);
    return requestExodus.post("".concat(streamURL, "/").concat(username), body);
};
/**
 * Get company stream data
 * @param {string} symbol
 *
 * @param {Object} param
 * @param {number} param.beforelastpost
 * @param {string} param.category
 * @param {number} param.lastpost
 * @param {*} param.keyword
 * @param {number} param.limit
 * @param {string} param.from
 * @param {string} param.to
 * @returns {APIResponse}
 */ var getSymbolStream = function(symbol, param) {
    var _category = param.category, category = _category === void 0 ? "all" : _category, _lastpost = param.lastpost, lastpost = _lastpost === void 0 ? 0 : _lastpost, keyword = param.keyword, _limit = param.limit, limit = _limit === void 0 ? 20 : _limit, _from = param.from, from = _from === void 0 ? "" : _from, _to = param.to, to = _to === void 0 ? "" : _to, _reporttype = param.reporttype, reporttype = _reporttype === void 0 ? "" : _reporttype;
    var streamURL = "".concat(STREAM_EXODUS_V3_URL, "/symbol");
    var body = {};
    body = {
        category: global_StreamWidget_constants__WEBPACK_IMPORTED_MODULE_3__/* .TAB_CATEGORIES */ .oK[category],
        last_stream_id: lastpost,
        keyword: keyword,
        from_date: from,
        to_date: to,
        limit: limit
    };
    if (reporttype) {
        // eslint-disable-next-line dot-notation
        body["report_type"] = global_StreamWidget_constants__WEBPACK_IMPORTED_MODULE_3__/* .STREAM_REPORT */ .OW[reporttype];
    }
    body = (0,utils_stream__WEBPACK_IMPORTED_MODULE_4__/* .cleanupStreamPayload */ .Hm)(body);
    return requestExodusNoAlert.post("".concat(streamURL, "/").concat(symbol), body);
};
/**
 * Get stream post detail by post id
 * @param {string} symbol
 * @returns {APIResponse}
 */ var getGuestStream = function(symbol) {
    return requestExodusNoAlert.get("".concat(STREAM_EXODUS_URL, "/non-login/symbol/").concat(symbol));
};
/**
 * Get company data for guest
 * @param {string} symbol
 * @returns {APIResponse}
 */ var getGuestCompany = function(symbol) {
    return requestExodusNoAlert.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/emitten/non-login/").concat(symbol, "/info"));
};
/**
 * Get company profile info
 * @param {string} symbol
 * @returns {APIResponse}
 */ var getGuestCompanyProfile = function(symbol) {
    return requestExodusNoAlert.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/partnership/emitten/").concat(symbol, "/profile"));
};
/**
 * Get chart data for guest
 * @param {string} symbol
 * @returns {APIResponse}
 */ var getGuestChart = function(symbol) {
    var timeframe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "today";
    return requestExodusNoAlert.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/partnership/charts/").concat(symbol, "/daily?timeframe=").concat(timeframe));
};
/**
 * Get stream post detail by post id
 * @param {string|number} postId
 * @returns {APIResponse}
 */ var getStreamDetail = function(postId) {
    var streamURL = "".concat(STREAM_EXODUS_V3_URL, "/post/").concat(postId);
    return requestExodusNoAlert.post(streamURL);
};
/**
 * Get stream post detail by post id
 * @param {string|number} postId
 * @returns {APIResponse}
 */ var getGuestStreamDetail = function(postId) {
    return requestExodusNoAlert.get("".concat(STREAM_EXODUS_URL, "/non-login/post/").concat(postId));
};
/**
 * getUploadToken
 * @param {string} bucket - bucket'sname
 * @returns {APIResponse}
 */ var getUploadToken = function() {
    var bucket = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "avatar";
    return requestExodusNoAlert.get("".concat(STREAM_UPLOAD_TOKEN), {
        params: {
            bucket: bucket
        }
    });
};
/**
 * postUploadAWS
 * @param {object} formData - file formdata
 * @returns {APIResponse}
 */ var postUploadAWS = function(formData) {
    return fetch(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .AWS_AVATAR_BUCKET */ .cU, {
        method: "POST",
        cache: "default",
        body: formData,
        mode: "cors"
    }).then(function(response) {
        if (response.status === 200) {
            return response.json();
        }
        // TODO: alert error message
        return false;
    });
};
/**
 * API Compose new Stream
 * @param {Object} param
 * @param {string} param.content
 * @param {string} param.image
 * @param {Array} param.images
 * @param {Object} param.file
 * @param {number} param.target_price
 * @param {string} param.target_symbol
 * @param {number} param.target_duration
 * @param {Object=} param.polling
 * @param {string} param.commenter_type
 * @returns {APIResponse}
 */ var postStream = function(param) {
    var content = param.content, image = param.image, _images = param.images, images = _images === void 0 ? [] : _images, _file = param.file, file = _file === void 0 ? "" : _file, target_price = param.target_price, target_symbol = param.target_symbol, target_duration = param.target_duration, polling = param.polling, commenter_type = param.commenter_type;
    var data = {
        content: content,
        image: image,
        images: images,
        file: file,
        target_price: target_price,
        target_symbol: target_symbol,
        target_duration: target_duration,
        sharefacebook: 0,
        sharetwitter: 0,
        commenter_type: commenter_type
    };
    if (polling) {
        data.polling_end = polling.polling_end;
        data.polling_options = polling.polling_options;
        data.polling_pin = polling.polling_pin;
    }
    return requestExodus.post("".concat(STREAM_EXODUS_URL, "/write"), data);
};
/**
 * API Update Post Stream
 * @param {Object} param
 * @param {string} param.content
 * @param {string} param.image
 * @param {Array} param.images
 * @param {Object} param.file
 * @param {number} param.target_price
 * @param {string} param.target_symbol
 * @param {number} param.target_duration
 * @param {Object=} param.polling
 * @param {number} param.postid
 * @param {string} param.commenter_type
 * @returns {APIResponse}
 */ var updatePostStream = function(param) {
    var content = param.content, image = param.image, _images = param.images, images = _images === void 0 ? [] : _images, _file = param.file, file = _file === void 0 ? "" : _file, target_price = param.target_price, target_symbol = param.target_symbol, target_duration = param.target_duration, polling = param.polling, postid = param.postid, commenter_type = param.commenter_type;
    var data = {
        content: content,
        image: image,
        images: images,
        file: file,
        target_price: target_price,
        target_symbol: target_symbol,
        target_duration: target_duration,
        sharefacebook: 0,
        sharetwitter: 0,
        commenter_type: commenter_type
    };
    if (polling) {
        data.polling_end = polling.polling_end;
        data.polling_options = polling.polling_options;
        data.polling_pin = polling.polling_pin;
    }
    return requestExodus.post("".concat(STREAM_EXODUS_URL, "/update/").concat(postid), data);
};
/**
 * API Share Post Stream
 * @param {Object} param
 * @param {string} param.content
 * @param {string} param.images
 * @param {Object} param.file
 * @param {number} param.postid
 * @param {number=} param.facebook
 * @param {number=} param.twitter
 * @param {number=} param.stockbit
 * @param {number=} param.commenter_type
 * @returns {APIResponse}
 */ var sharePostStream = function(param) {
    var content = param.content, images = param.images, file = param.file, postid = param.postid, _facebook = param.facebook, facebook = _facebook === void 0 ? 0 : _facebook, _twitter = param.twitter, twitter = _twitter === void 0 ? 0 : _twitter, _stockbit = param.stockbit, stockbit = _stockbit === void 0 ? 0 : _stockbit, commenter_type = param.commenter_type;
    var data = {
        postid: postid,
        content: content,
        images: images,
        file: file,
        facebook: facebook,
        twitter: twitter,
        stockbit: stockbit,
        commenter_type: commenter_type
    };
    return requestExodus.post("".concat(STREAM_EXODUS_URL, "/share/").concat(postid), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, data));
};
/**
 * Function to post vote to target price post
 * @param {number} targetPriceId - target price id
 * @param {0 | 1} agree - agree status 1: agree, 0: disagree
 * @returns {APIResponse}
 */ var postVoteTargetPrice = function(targetPriceId, agree) {
    var bodyFormData = new URLSearchParams();
    bodyFormData.append("tp_id", targetPriceId);
    bodyFormData.append("agree", agree);
    return requestExodusNoAlert.post("".concat(STREAM_EXODUS_URL, "/addvote/").concat(targetPriceId), bodyFormData);
};
/**
 * Follow Post
 * @param {number|string} postid
 * @returns {APIResponse}
 */ var followPost = function(postid) {
    return requestExodusNoAlert.post("".concat(STREAM_EXODUS_URL, "/follow/").concat(postid));
};
/**
 * UnFollow Post
 * @param {number|string} postid
 * @returns {APIResponse}
 */ var unfollowPost = function(postid) {
    return requestExodusNoAlert.post("".concat(STREAM_EXODUS_URL, "/unfollow/").concat(postid));
};
/**
 * Save Post
 * @param {number|string} postid
 * @returns {APIResponse}
 */ var savePost = function(postid) {
    return requestExodus.post("".concat(STREAM_EXODUS_URL, "/save/").concat(postid));
};
/**
 * UnSave Post
 * @param {number|string} postid
 * @returns {APIResponse}
 */ var unsavePost = function(postid) {
    return requestExodusNoAlert.post("".concat(STREAM_EXODUS_URL, "/unsave/").concat(postid));
};
/**
 *  Get Announcement Report
 * @param {number|string} postid
 * @returns {APIResponse}
 */ var getAnnouncementReports = function(postid) {
    return requestExodusNoAlert.get("".concat(STREAM_EXODUS_URL, "/announcement/").concat(postid));
};
/**
 * Post Report Stream
 * @param {number|string} postid
 * @param {string} type
 * @param {string} message
 * @returns {APIResponse}
 */ var postReportStream = function(postid, type, message) {
    var form = new URLSearchParams();
    form.append("type", type);
    form.append("message", message);
    return requestExodus.post("".concat(STREAM_EXODUS_URL, "/report/").concat(postid), form);
};
/**
 * Delete Post Stream
 * @param {number|string} postid
 * @param {string} reason
 * @param {boolean} sendEmail
 * @returns {APIResponse}
 */ var deletePostStream = function(postid, reason) {
    var sendEmail = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var data = {
        reason: reason,
        send_email: sendEmail
    };
    return requestExodus.post("".concat(STREAM_EXODUS_URL, "/v2/delete/").concat(postid), data);
};
/**
 * Delete Own Post Stream
 * @param {number|string} postid
 * @returns {APIResponse}
 */ var deleteOwnPostStream = function(postid) {
    return requestExodus.delete("".concat(STREAM_EXODUS_URL, "/own/").concat(postid));
};
/**
 * Delete Own Post Stream
 * @param {number|string} postid
 * @returns {APIResponse}
 */ var deleteOwnPostComment = function(postid) {
    return requestExodus.delete("".concat(STREAM_EXODUS_URL, "/own/comment/").concat(postid));
};
/**
 * Delete Multiple Post Stream
 * @param {number|string} userid
 * @param {string} time
 * @param {string} reason
 * @param {bool} sendEmail
 * @returns {APIResponse}
 */ var deleteMultiplePostStream = function(userid, time, reason) {
    var sendEmail = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var data = {
        user_id: userid,
        period: time,
        send_email: sendEmail,
        reason: reason
    };
    return requestExodus.post("".concat(STREAM_EXODUS_URL, "/delete/multiple"), data);
};
/**
 * Pin Post
 * @param {number|string} postid
 * @param {string} symbol
 * @returns {APIResponse}
 */ var pinPost = function(postid, symbol) {
    var data = new URLSearchParams();
    data.append("postid", postid);
    if (symbol) data.append("symbol", symbol);
    return requestExodus.post("".concat(STREAM_EXODUS_URL, "/pin?").concat(data.toString()));
};
/**
 * UnPin Post
 * @param {number|string} postid
 * @param {string} symbol
 * @returns {APIResponse}
 */ var unpinPost = function(postid, symbol) {
    var data = new URLSearchParams();
    data.append("postid", postid);
    if (symbol) data.append("symbol", symbol);
    return requestExodus.post("".concat(STREAM_EXODUS_URL, "/unpin?").concat(data.toString()));
};
/**
 * Get user pinned post
 * @param {string} username
 * @returns {APIResponse}
 */ var getPinnedPost = function(username) {
    return requestExodusNoAlert.post("".concat(STREAM_EXODUS_V3_URL, "/user/").concat(username, "/pinned"));
};
/**
 * Get company pinned post
 * @param {string} symbol
 * @returns {APIResponse}
 */ var getCompanyPinnedPost = function(symbol) {
    return requestExodusNoAlert.get("/stream/v3/symbol/".concat(symbol, "/pinned"));
};
/**
 * Get Stream Conversation
 * @param {number|string} postid
 * @returns {APIResponse}
 */ var getStreamConversation = function(param) {
    var postId = param.postId, parentId = param.parentId;
    var streamURL = "".concat(STREAM_EXODUS_V3_URL, "/conversation");
    var body = {
        stream_id: postId,
        limit: 20
    };
    var parentID = parentId > 0 ? parentId : postId;
    body = (0,utils_stream__WEBPACK_IMPORTED_MODULE_4__/* .cleanupStreamPayload */ .Hm)(body);
    return requestExodusNoAlert.post("".concat(streamURL, "/").concat(parentID), body);
};
/**
 * Get Prev Stream Conversation
 * @param {number|string} postid
 * @returns {APIResponse}
 */ var getPrevStreamConversation = function(postid) {
    var streamURL = "".concat(STREAM_EXODUS_V3_URL, "/conversation");
    var body = {
        stream_id: postid,
        is_previous: true,
        limit: 20
    };
    body = (0,utils_stream__WEBPACK_IMPORTED_MODULE_4__/* .cleanupStreamPayload */ .Hm)(body);
    return requestExodusNoAlert.post("".concat(streamURL, "/comments"), body);
};
/**
 * Post Reply Stream
 * @param {Object} param
 * @param {string=} param.content
 * @param {string=} param.image
 * @param {string=} param.images
 * @param {Object=} param.file
 * @param {number=} param.postid
 * @param {number} param.replyto
 * @param {number|string} param.parent
 * @returns {APIResponse}
 */ var postReplyStream = function(param) {
    var _content = param.content, content = _content === void 0 ? "" : _content, _image = param.image, image = _image === void 0 ? null : _image, _images = param.images, images = _images === void 0 ? [] : _images, _file = param.file, file = _file === void 0 ? null : _file, replyto = param.replyto, parent = param.parent;
    var data = {
        content: content,
        image: image,
        images: images,
        file: file,
        sharefacebook: 0,
        sharetwitter: 0
    };
    if (replyto) {
        data.replyto = replyto;
    }
    return requestExodus.post("".concat(STREAM_EXODUS_URL, "/reply/").concat(parent), data);
};
/**
 * Untag all post topics inside stream post
 * @param {number} postId - Stream post ID
 * @returns {APIResponse}
 */ var untagPostTopic = function(postId) {
    return requestExodus.post("".concat(STREAM_EXODUS_URL, "/topic/untag/").concat(postId));
};
/**
 * Get stream likers
 * @param {string} username
 * @param {string | number} postid
 * @param {number} page
 * @return {APIResponse}
 */ var getStreamLikers = function(username, postid) {
    var page = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
    return requestExodusNoAlert.get("".concat(STREAM_EXODUS_URL, "/likers/").concat(postid), {
        params: {
            username: username,
            page: page
        }
    });
};
/**
 * getUploadToken version 2
 * @param {string} filename
 * @returns {APIResponse}
 */ var getUploadTokenV2 = function(params) {
    return requestExodusNoAlert.get("".concat(STREAM_UPLOAD_TOKEN_V2), {
        params: params
    });
};
/**
 * Change Commenter Type of Post
 * @param {number} type - Stream post Commenter Type
 * @param {string | number} postid
 * @returns {APIResponse}
 */ var changeCommenterType = function(type, postid) {
    return requestExodus.put("".concat(STREAM_EXODUS_URL, "/commenter-type/").concat(postid), {
        commenter_type: type
    });
};
/**
 * Post Polling Vote
 * @param {number} pollingId - Stream post ID
 * @param {number} option - selected option
 * @returns {APIResponse}
 */ var postPollingVote = function(pollingId, option) {
    return requestExodus.post("".concat(STREAM_EXODUS_URL, "/polling/vote/").concat(pollingId), {
        option: option
    });
};
var getGuestUserStream = function(username) {
    return requestExodusNoAlert.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/stream/non-login/user/").concat(username));
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    likeStreamPost: likeStreamPost,
    unlikeStreamPost: unlikeStreamPost,
    getStream: getStream,
    getUserStream: getUserStream,
    getSymbolStream: getSymbolStream,
    getStreamDetail: getStreamDetail,
    getUploadToken: getUploadToken,
    postUploadAWS: postUploadAWS,
    postStream: postStream,
    updatePostStream: updatePostStream,
    sharePostStream: sharePostStream,
    postVoteTargetPrice: postVoteTargetPrice,
    followPost: followPost,
    unfollowPost: unfollowPost,
    savePost: savePost,
    unsavePost: unsavePost,
    getAnnouncementReports: getAnnouncementReports,
    postReportStream: postReportStream,
    deletePostStream: deletePostStream,
    deleteOwnPostStream: deleteOwnPostStream,
    deleteOwnPostComment: deleteOwnPostComment,
    deleteMultiplePostStream: deleteMultiplePostStream,
    pinPost: pinPost,
    unpinPost: unpinPost,
    getPinnedPost: getPinnedPost,
    getCompanyPinnedPost: getCompanyPinnedPost,
    getStreamLikers: getStreamLikers,
    getStreamConversation: getStreamConversation,
    getPrevStreamConversation: getPrevStreamConversation,
    postReplyStream: postReplyStream,
    untagPostTopic: untagPostTopic,
    getUploadTokenV2: getUploadTokenV2,
    getGuestStreamDetail: getGuestStreamDetail,
    getGuestStream: getGuestStream,
    getGuestCompany: getGuestCompany,
    getGuestCompanyProfile: getGuestCompanyProfile,
    changeCommenterType: changeCommenterType,
    getGuestChart: getGuestChart,
    postPollingVote: postPollingVote,
    getGuestUserStream: getGuestUserStream
});


/***/ }),

/***/ 7639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ stores_useUIConfigStore; }
});

// UNUSED EXPORTS: resetRules

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./node_modules/zustand/esm/middleware.js
var middleware = __webpack_require__(38597);
// EXTERNAL MODULE: ./src/utils/auth.js
var auth = __webpack_require__(14229);
// EXTERNAL MODULE: ./src/typings/auth.ts
var typings_auth = __webpack_require__(97718);
;// CONCATENATED MODULE: ./src/utils/objectOperations.ts

var pickObject = function(obj, keys) {
    var pickedObject = {};
    keys.forEach(function(key) {
        pickedObject[key] = obj === null || obj === void 0 ? void 0 : obj[key];
    });
    return pickedObject;
};
var omitObject = function(obj, keys) {
    var omittedObject = (0,_object_spread/* default */.Z)({}, obj);
    keys.forEach(function(key) {
        return delete omittedObject[key];
    });
    return omittedObject;
};

;// CONCATENATED MODULE: ./src/stores/useUIConfigStore/index.ts









var _obj;
var resetRules = (_obj = {}, // List item that should not deleted on social logout
(0,_define_property/* default */.Z)(_obj, typings_auth/* LoginType.Social */.B.Social, [
    "tradingLimitTooltip",
    "tradingLimitTnc",
    // Day Trade
    "dayTradeTnc",
    "dayTradeTncShown", 
]), // List item that should be deleted on securities logout
(0,_define_property/* default */.Z)(_obj, typings_auth/* LoginType.Securities */.B.Securities, [
    "featureFlags"
]), _obj);
var initialState = {
    userConfig: {}
};
var useUIConfigStore = (0,esm/* default */.ZP)((0,middleware/* persist */.tJ)(function(set, get) {
    var ref, ref1, ref2;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        setUIValue: function(key, value) {
            var userId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (ref = auth/* default.getUserAccess */.Z.getUserAccess()) === null || ref === void 0 ? void 0 : ref.id;
            set((0,immer_esm/* default */.ZP)(function(state) {
                if (!state.userConfig[userId]) state.userConfig[userId] = {};
                if (typeof value === "function") {
                    if (!state.userConfig[userId][key]) {
                        state.userConfig[userId] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.userConfig[userId]), (0,_define_property/* default */.Z)({}, key, {}));
                    }
                    value(state.userConfig[userId][key]);
                    return;
                }
                state.userConfig[userId][key] = value;
            }));
        },
        getUIValue: function(key) {
            var userId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (ref1 = auth/* default.getUserAccess */.Z.getUserAccess()) === null || ref1 === void 0 ? void 0 : ref1.id;
            var ref;
            return (ref = get().userConfig[userId]) === null || ref === void 0 ? void 0 : ref[key];
        },
        resetUIValue: function(loginType) {
            var userId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (ref2 = auth/* default.getUserAccess */.Z.getUserAccess()) === null || ref2 === void 0 ? void 0 : ref2.id;
            var resetSocial = function() {
                set((0,immer_esm/* default */.ZP)(function(state) {
                    state.userConfig[userId] = pickObject(state.userConfig[userId], resetRules[typings_auth/* LoginType.Social */.B.Social]);
                }));
            };
            var resetSecurities = function() {
                set((0,immer_esm/* default */.ZP)(function(state) {
                    state.userConfig[userId] = omitObject(state.userConfig[userId], resetRules[typings_auth/* LoginType.Securities */.B.Securities]);
                }));
            };
            var _obj;
            var resetActions = (_obj = {}, (0,_define_property/* default */.Z)(_obj, typings_auth/* LoginType.Social */.B.Social, resetSocial), (0,_define_property/* default */.Z)(_obj, typings_auth/* LoginType.Securities */.B.Securities, resetSecurities), _obj);
            resetActions[loginType]();
        }
    });
}, {
    name: "UIConfigStore"
}));
/* harmony default export */ var stores_useUIConfigStore = (useUIConfigStore);


/***/ }),

/***/ 97718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ LoginType; },
/* harmony export */   "z": function() { return /* binding */ OtpChannel; }
/* harmony export */ });
var LoginType;
(function(LoginType) {
    LoginType["Social"] = "social";
    LoginType["Securities"] = "securities";
})(LoginType || (LoginType = {}));
var OtpChannel;
(function(OtpChannel) {
    OtpChannel["Unspecified"] = "CHANNEL_UNSPECIFIED";
    OtpChannel["Sms"] = "CHANNEL_SMS";
    OtpChannel["WhatsApp"] = "CHANNEL_WHATSAPP";
})(OtpChannel || (OtpChannel = {}));


/***/ }),

/***/ 78603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IL": function() { return /* binding */ uploadFiles; },
/* harmony export */   "Ox": function() { return /* binding */ generateId; }
/* harmony export */ });
/* unused harmony exports convertToSlug, formatUploadFileName */
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82670);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37213);
/* harmony import */ var constants_errorMessage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61608);
/* harmony import */ var global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25516);
/* harmony import */ var lib_api_stream__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51679);
/* eslint-disable no-console */ /* eslint-disable no-useless-escape */ 




function convertToSlug(text) {
    if (!text) return text;
    return text.toString().toLowerCase().replace(/\s+/g, "-") // Replace spaces with -
    .replace(/[^\w\-]+/g, "") // Remove all non-word chars
    .replace(/\-\-+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-$/, ""); // Trim - from end of text
}
var generateId = function() {
    // @ts-ignore
    var crypto = (window === null || window === void 0 ? void 0 : window.crypto) || (window === null || window === void 0 ? void 0 : window.msCrypto);
    var array = new Uint32Array(1);
    crypto.getRandomValues(array); // Compliant for security-sensitive use cases
    var id = array[0];
    return id;
};
var formatUploadFileName = function(file) {
    // eslint-disable-next-line no-bitwise
    var extension = file.slice((file.lastIndexOf(".") - 1 >>> 0) + 2); // Returning only file extension, safeguarding from 'filename' or '.filename'
    var filename = file.substr(0, file.lastIndexOf("."));
    var randomId = generateId();
    var d = new Date();
    var currDate = String("00".concat(d.getDate())).slice(-2); // Get today's date with leading zero
    var currMonth = String("00".concat(d.getMonth() + 1)).slice(-2); // Get today's month with leading zero
    var currYear = d.getFullYear();
    return "".concat(convertToSlug("".concat(filename, " ").concat(randomId).concat(currYear).concat(currMonth).concat(currDate)), ".").concat(extension);
};
/**
 * Creating upload file promise object
 * @param {Object} file
 * @param {String} token
 * @returns {Promise}
 */ var createUploadPromise = function(file, token) {
    var bucket = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "stockbit";
    /**
   * If an old url file is being passed, return the passed url instead.
   * The old file validation process works by checking if the filename sent is
   * a string and an url with http or https
   */ if (typeof file === "string" && file.indexOf("http") !== -1) {
        return Promise.resolve({
            data: {
                url: file
            }
        });
    }
    // Generate unique filename
    var fileName = (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(file, File) ? file.name : String(file.split("/").pop());
    var newFileName = formatUploadFileName(fileName);
    var fd = new FormData();
    var formerFile = null;
    // eslint-disable-next-line no-underscore-dangle
    if (file._file) formerFile = file._file;
    fd.append("key", newFileName);
    fd.append("AWSAccessKeyId", token.AWSAccessKeyId);
    fd.append("acl", "public-read");
    fd.append("success_action_redirect", token.success_action_redirect);
    fd.append("policy", token.policy);
    fd.append("signature", token.signature);
    fd.append("Content-Type", "");
    if (!formerFile) {
        fd.append("file", file);
    } else {
        fd.append("file", formerFile);
    }
    var awsBucket = constants_api__WEBPACK_IMPORTED_MODULE_0__/* .AWS_IMAGES_BUCKET */ .Me;
    if (bucket === "simasreg") awsBucket = constants_api__WEBPACK_IMPORTED_MODULE_0__/* .AWS_TRADE_REG_BUCKET */ .vw;
    if (bucket === "avatar") awsBucket = constants_api__WEBPACK_IMPORTED_MODULE_0__/* .AWS_AVATAR_BUCKET */ .cU;
    return fetch(awsBucket, {
        method: "POST",
        cache: "default",
        body: fd,
        mode: "cors"
    }).then(function(response) {
        return response.json();
    }).catch(function(err) {
        ;
        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(constants_errorMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"].STREAM_ERROR_UPLOAD_FILE */ .Z.STREAM_ERROR_UPLOAD_FILE, constants_errorMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ALERT_RED */ .Z.ALERT_RED);
        return err;
    });
};
/**
 * Upload files stacked into Amazon S3
 * @param {Array} files
 * @returns {Object}
 */ var uploadFiles = function() {
    var files = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], bucket = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "stockbit";
    return lib_api_stream__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getUploadToken */ .Z.getUploadToken(bucket).then(function(res) {
        var _data = res.data, token = _data.data;
        var collection = [];
        // eslint-disable-next-line no-unused-vars
        var mappingFiles = files.map(function(file) {
            var uploadPromise = createUploadPromise(file, token, bucket);
            collection.push(uploadPromise);
            return file;
        });
        return Promise.all(collection).then(function(data) {
            return data;
        }).catch(function(err) {
            return console.error("MUNCUL ERROR", err);
        });
    });
};


/***/ })

}]);